import { useState } from "react";

export function useLocalStorage<T>(key: string, defaultValue: T) {
  const [value, setValue] = useState<T>(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored !== null ? (JSON.parse(stored) as T) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  const setStoredValue = (next: T) => {
    try {
      localStorage.setItem(key, JSON.stringify(next));
    } catch {
      // ignore write errors
    }
    setValue(next);
  };

  return [value, setStoredValue] as const;
}
